var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"10","height":"10","rx":"5","stroke-linecap":"square","stroke-linejoin":"round","stroke-dasharray":"3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }